import { ContextItem, RequirementTableItemData } from "../../../../types";
import { WSQueryCache } from "@ws-react-query";
import { InsuranceCoverageMonitor } from "../../../../../../services/api/insurance/monitor/types";
import { QUERY_INSURANCE_COVERAGE_MONITOR } from "../../../../../../query/insuranceCoverageMonitor/queries/useInsuranceCoverageMonitorQuery";

export const getInsuranceCoverageRequestFromCache = (
  requirement: RequirementTableItemData,
  _context: ContextItem
): InsuranceCoverageMonitor | undefined => {
  if (!requirement.dataSourceId) {
    return undefined;
  }

  const cache = WSQueryCache.getQueryData<InsuranceCoverageMonitor>([
    QUERY_INSURANCE_COVERAGE_MONITOR,
    requirement.dataSourceId
  ]);

  return cache;
};
